import { useActionHandler, ActionHandlerOptions } from "./useActionHandler";
import {
  getRecentActivityLogs,
  getActivityLogs,
  getUnviewedActivityCount,
  markActivityLogAsViewed,
  markAllActivityLogsAsViewed,
} from "@/server-side/actions/activityLogs";
import { useCallback } from "react";

export function useActivityLogActions() {
  const { handleAction } = useActionHandler();

  const getRecentActivityLogsAction = useCallback(async (
    options?: ActionHandlerOptions
  ) => {
    return handleAction(getRecentActivityLogs(), options);
  }, [handleAction]);

  const getActivityLogsAction = useCallback(async (
    limit: number,
    options?: ActionHandlerOptions
  ) => {
    return handleAction(getActivityLogs(limit), options);
  }, [handleAction]);

  const getUnviewedActivityCountAction = useCallback(async (
    options?: ActionHandlerOptions
  ) => {
    return handleAction(getUnviewedActivityCount(), options);
  }, [handleAction]);

  const markActivityLogAsViewedAction = useCallback(async (
    activityLogId: string,
    options?: ActionHandlerOptions
  ) => {
    return handleAction(markActivityLogAsViewed(activityLogId), options);
  }, [handleAction]);

  const markAllActivityLogsAsViewedAction = useCallback(async (
    options?: ActionHandlerOptions
  ) => {
    return handleAction(markAllActivityLogsAsViewed(), options);
  }, [handleAction]);

  return {
    getRecentActivityLogs: getRecentActivityLogsAction,
    getActivityLogs: getActivityLogsAction,
    getUnviewedActivityCount: getUnviewedActivityCountAction,
    markActivityLogAsViewed: markActivityLogAsViewedAction,
    markAllActivityLogsAsViewed: markAllActivityLogsAsViewedAction,
  };
}
